module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/sidebar/zh-hant-15d456465bce2dcf92a91858630246b1.jpeg";